export const filesManager = {
    tabs: {
        'allFiles': 'Todos los archivos',
        'usersWithFiles': 'Usuarios con archivos',
        'file': 'Archivo',
        'permissions': 'Permisos'
    },
    titles: {
        fileListing: 'Listado de archivos',
        fileRepository: 'Repositorio de archivos',
        mineFile: 'Archivo propio',
        createFile: 'Creación de archivo',
        basicConfiguration: 'Configuración básica',
        requestingUsers: 'Usuarios solicitantes',
        typeFile: 'Tipo',
        sizeFile: 'Tamaño',
        selectUsersToAccess: 'Seleccione usuarios que tendrán acceso a este archivo',
        usersWithPermission: 'Usuarios con permisos para este archivo',
        selectUsersToAdd: 'Seleccione los usuarios que desea agregar',
        backToTableUser: '¿Desea regresar a la tabla de usuarios?',
        fileCreatedSuccess: 'El archivo se creó exitosamente',
        fileDetail: 'Detalle del archivo',
        fileEdition: 'Edición de archivo',
        userCreator: 'Usuario creador',
        file: 'Archivo',
        aboutTheFile: 'Sobre el archivo',
        displayAndExpiration: 'Visualización y expiración',
        solicitedUsers: 'Usuarios solicitantes',
        usersWithoutSelect: 'Usuario sin seleccionar',
        noUsersSolicited: 'No hay usuarios solicitantes',
        usersWithFilesAssigned: 'Usuarios con archivos asignados',
    },
    subtitles: {
        selectUsersToAssignHowSolicited: 'Seleccione los usuarios a asignar como solicitantes',
        aboutTheUser: 'Acerca del usuario',
        fileList: 'Listado de archivos',
        addFile: 'Agregar archivo',
        creationDate: 'Fecha de creación',
    },
    messages: {
        whitoutUsersYouCanAdd: 'Sin usuarios solicitantes, puedes agregar uno o varios usuarios',
        withoutUserWithPermissions: 'Sin usuarios con permisos, puedes agregar uno o varios usuarios',
        notFindUsers: 'No se ha encontrado usuarios, puedes usar los filtros para consultar usuarios'
    },
    tags: {
        role: 'Rol',
        area: 'Área',
        department: 'Departamento',
        userType: 'Tipo de usuario',
        type: 'Tipo',
        size: 'Tamaño',
        createDate: 'Fecha de creación',
        editDate: 'Fecha de modificación',
        search: 'Buscar',
        fileType: 'Tipo',
        creationDate: 'Fecha de creación',
        percentage: 'Rango de tamaño'
    },
    buttons: {
        delete: 'Eliminar',
        backToList: 'Regresar al listado',
        backToDetail: 'Regresar al detalle',
        backToListSecond: 'Volver al listado',
        back: 'Regresar',
        backToFilesList: 'Regresar al listado de archivos',
        addFile: 'Agregar archivo',
        continue: 'Continuar',
        csvFiles: 'Archivos Excel',
        wordFiles: 'Archivos Word',
        pdfFiles: 'Archivos Pdf'
    },
    columns: {
        area: 'Área',
        department: 'Departamento',
        fileName: 'Nombre del archivo',
        userName: 'Nombre del usuario',
        role: 'Rol',
        userType: 'Tipo de usuario',
        creationDate: 'Fecha de creación',
        expirationDate: 'Fecha de expiración',
        solicitedUsers: 'Usuarios solicitantes',
        fileSize: 'Tamaño del archivo',
        type: 'Tipo',
        size: 'Tamaño',
        status: 'Estatus',
        action: 'Acciones'
    },
    snackbar: {
        selectAtLeastOneFile: 'Debes seleccionar al menos un archivo para realizar esta acción',
        fileLoadedSuccess: 'El archivo se cargó exitosamente',
        fileLoadedError: 'Ocurrió un error al cargar el archivo',
        downloadFile: 'Descargando archivo',
        errorToCreateFile: 'Ocurrió un error al crear el archivo',
        'theFileIsTooLarge_image': 'El archivo es demasiado grande. El máximo permitido para imágenes es {{max}}MB.',
        'theFileIsTooLarge_video': 'El archivo es demasiado grande. El máximo permitido para videos es {{max}}MB.',
        'theFileIsTooLarge_document': 'El archivo es demasiado grande. El máximo permitido para documentos es {{max}}MB.',
        'generateFilesDownload_pdf': 'Generando descarga del listado de archivos en pdf',
        'generateFilesDownload_word': 'Generando descarga del listado de archivos en word',
        'generateFilesDownload_excel': 'Generando descarga del listado de archivos en excel',
        'unsupportedFileType': 'Formato de archivo no válido.',
        activateFile: 'El archivo ha sido activado con éxito',
        desactivateFile: 'El archivo ha sido desactivado con éxito',
        noActivateFile: 'El archivo no se pudo activar',
        noDesactivateFile: 'El archivo no se pudo desactivar',
        updateFile: 'El archivo se actualizó correctamente',
        updatePermissions: 'Los permisos se actualizaron correctamente',
        "delete": {
            "error": {
                "unique": "No se pudo eliminar el archivo.",
                "masive": "No se pudieron eliminar los archivos seleccionados."
            },
            "success": {
                "unique": "El archivo se eliminó correctamente.",
                "masive": "Los archivos seleccionados se eliminaron correctamente."
            }
        },
    },
    modal: {
        titles: {
            confirmation: 'Confirmación',
            backToList: '¿Estás seguro que quieres regresar al listado?',
            backToDetail: '¿Estás seguro que quieres regresar al detalle del archivo?',
            cancelEdition: '¿Estás seguro que deseas cancelar la edición?',
            youWantToDeleteThisFile: '¿Deseas eliminar el archivo cargado?',
            youWantToReplaceThisFile: '¿Deseas reemplazar el archivo existente?',
            deleteSettings: '¿Estás seguro de que quieres desactivar este permiso?',
            "deleteSettingsPermission_one": "¿Estás seguro de que quieres eliminar el usuario seleccionado?",
            "deleteSettingsPermission_other": "¿Estás seguro de que quieres eliminar los usuarios seleccionados?",
            "deleteFile_one": "¿Estás seguro de que quieres eliminar el archivo seleccionado?",
            "deleteFile_other": "¿Estás seguro de que quieres eliminar los archivos seleccionados?",

        },
        description: {
            'areYouSureToSaveThisFile': '¿Estás seguro que deseas crear este archivo?',
            'areYouSureWantDeleteAllFilesSelected_one': '¿Estás seguro que deseas eliminar este archivo?',
            'areYouSureWantDeleteAllFilesSelected_other': '¿Estás seguro que deseas eliminar los archivos seleccionados?',
            'areYouSureWantDeleteThisFileSelected': '¿Estás seguro que deseas eliminar este archivo?',
            'areYouSureWantActivateThisFile': '¿Estás seguro que deseas activar este archivo?',
            'areYouSureWantDesacctivateThisFile': '¿Estás seguro que deseas desactivar este archivo?',
            toBackTheChangesLost: 'Al regresar al listado, se perderán los cambios realizados.',
            toBackTheChangesLostDetail: 'Al regresar al detalle, se perderán los cambios realizados.',
            deleteSettings: 'Se perderá el permiso de descargar el archivo.',
            deletePermissionDescription: "Se perderán las configuraciones realizadas.",
            editThisFile: ' ¿Estás seguro que deseas editar este archivo?',
            deleteThisSolicitedUser: ' ¿Estás seguro que deseas eliminar este usuario solicitante?',
            savePermissionConfiguration: '¿Estás seguro que deseas guardar esta configuración de permisos?',
            cancelPermissionConfiguration: '¿Estás seguro que deseas cancelar la configuración de permisos? Los cambios que no han sido guardados se perderán',
            youSureAddFilesSelected: '¿Estás seguro que deseas agregar la selección de archivos?',
            noFilesToAdd: 'Los archivos que desea agregar ya se encuentran en la lista de archivos.',
            'filesHasbeenAdded_one': 'Se ha agregado 1 archivo exitosamente.',
            'filesHasbeenAdded_other': 'Se han agregado {{count}} archivos exitosamente.',
            areYouSureToSaveThgeFileslist: '¿Estás seguro que deseas guardar el listado de archivos de este usuario?',
            "deletedFiles_one": "El archivo seleccionado se eliminó correctamente",
            "deletedFiles_other": "Los archivos seleccionados se eliminaron correctamente",
            allFilesPermissionUpdated: "Los permisos de los archivos se actualizaron correctamente."

        }
    },
    tabsChildren: {
        addUsers: 'Agregar usuarios',
        permissions: 'Asignación de permisos'
    },
    fileTypes: {
        PDF: 'PDF',
        WORD: 'Word',
        CSV: 'CSV',
        EXCEL: 'Excel',
        POWERPOINT: 'PowerPoint',
        TXT: 'TXT',
        IMAGE: 'Imagen',
        VIDEO: 'Video',
    }
}